import { MemoryRouter, Route, Switch } from 'react-router-dom';

import { StatementPaths } from '../../app/enums/StatementPaths';
import InvoiceResultDisplay from '../invoice/InvoiceResultDisplay';
import InvoiceTransactionHistory from '../invoice/InvoiceTransactionHistory';
import { StatementSearch } from './StatementSearch';
import StatementResults from './StatementResults';
import { InvoicePaths } from '../../app/enums/InvoicePaths';

const getStatementRoutes = onClose => [
  {
    path: StatementPaths.SEARCH,
    render: routeProps => <StatementSearch {...routeProps} onClose={onClose} />,
  },
  {
    path: InvoicePaths.DETAIL,
    component: InvoiceResultDisplay,
  },
  {
    path: StatementPaths.RESULTS,
    component: StatementResults,
  },
  {
    path: InvoicePaths.TRANSACTION_HISTORY,
    render: routeProps => (
      <InvoiceTransactionHistory
        {...routeProps}
        backLabelId="statement.backToStatement"
      />
    ),
  },
];

export default function StatementDrawerContent({ onClose }) {
  return (
    <MemoryRouter initialEntries={[StatementPaths.SEARCH]}>
      <Switch>
        {getStatementRoutes(onClose).map(
          ({ path, component: Component, render }) => (
            <Route
              key={path}
              path={path}
              render={routeProps =>
                render ? render(routeProps) : <Component {...routeProps} />
              }
            />
          )
        )}
      </Switch>
    </MemoryRouter>
  );
}
